import React, { useEffect } from "react";
import { useArrayContext } from "../../../state/ArrayContext";
import { useSiteContext } from "../../../state/SiteContext";
import { MetadataRequest } from "../../../shared/models/metadata-request.model";
import { useFilterContext } from "../../../state/FilterContext";
import { Metadata } from "../../../shared/models/metadata.model";
import { services } from "../../../globals";
import { mapMetadataToItem } from "../../../shared/utils/source-item.utils";

interface UsedByQueryProps {
    contentType?: string,
    path: string,
}

/***
 * Array source that returns the result of searching for similar files.
 */
export const UsedByQuery = React.memo(function UsedByQuery({ contentType, path }: UsedByQueryProps): React.ReactElement {
    const { setArray } = useArrayContext();
    const { siteState } = useSiteContext();
    const { filterState } = useFilterContext();

    useEffect(() => {
        let isMounted = true;
        const fetchData = async () => {
            if (siteState.site?.name) {
                const request: MetadataRequest = { ...filterState };
                delete request.text;
                delete request.customProperties;
                request.systemProperties = { ...filterState.systemProperties };
                delete request.systemProperties?.type;
                contentType && (request.contentType = contentType);
                request.includes = path;
                const searchlist: Array<Metadata> = await services.search.search(
                    siteState.site.name,
                    request,
                );
                const result = searchlist.map((hit, ix) => {
                    return { ...mapMetadataToItem(hit), position: ix + 1 };
                });
                if (isMounted) {
                    setArray(result);
                }
            }
        };
        fetchData();
        return () => { isMounted = false; };
    }, [siteState, filterState, contentType, setArray, path]);

    return <></>;
});